<template>
  <div class="qualifications">
    <div class="content">
      <div class="qualifications__introduce">
        <div class="qualifications__introduce__title vertical-align">
          <img class="logo middle" src="@/assets/store/shangjia.png" />
          <span class="middle">商家介绍</span>
        </div>
        <div class="qualifications__introduce__content" style="white-space: pre-wrap">
          {{ qualifications.summary.trim() }}
        </div>
      </div>
      <!--      <div class="qualifications__introduce">-->
      <!--        <div class="qualifications__introduce__title vertical-align">-->
      <!--          <img class="logo middle" src="@/assets/store/jingying.png" />-->
      <!--          <span class="middle">经营范围</span>-->
      <!--        </div>-->
      <!--        <div class="qualifications__introduce__content">-->
      <!--          {{ qualifications.businessCategory }}-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div class="qualifications__introduce">-->
      <!--        <div class="qualifications__introduce__title vertical-align">-->
      <!--          <img class="logo middle" src="@/assets/store/peisong.png" />-->
      <!--          <span class="middle">配送方式</span>-->
      <!--        </div>-->
      <!--        <div v-if="qualifications.delivery" class="qualifications__introduce__content">-->
      <!--          {{ qualifications.delivery.minDeliveryAmount }}元起送，{{-->
      <!--            qualifications.delivery.parcelAmount-->
      <!--          }}元包邮，不足包邮金额需支付{{ qualifications.delivery.freight }}元运费，{{ qualifications.delivery.remark }}-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div v-if="qualifications.invoice" class="qualifications__introduce">-->
      <!--        <div class="qualifications__introduce__title vertical-align">-->
      <!--          <img class="logo middle" src="@/assets/store/fapiao.png" />-->
      <!--          <span class="middle">发票说明</span>-->
      <!--        </div>-->
      <!--        <div class="qualifications__introduce__content">-->
      <!--          支持开具{{ invoiceDesc }}，支持{{ qualifications.invoice.sendTime }}，如有遗漏，请联系客服。-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div class="qualifications__introduce">-->
      <!--        <div class="qualifications__introduce__title vertical-align">-->
      <!--          <img class="logo middle" src="@/assets/store/shouhou.png" />-->
      <!--          <span class="middle">售后说明</span>-->
      <!--        </div>-->
      <!--        <div class="qualifications__introduce__content">-->
      <!--          {{ qualifications.refundNotice }}-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="qualifications__introduce">
        <div class="qualifications__introduce__title vertical-align">
          <img class="logo middle" src="@/assets/store/zhengjian.png" />
          <span class="middle">相关证件</span>
        </div>
        <div class="qualifications__introduce__list">
          <div v-for="card in qualifications.certificates" :key="card.id" class="qualifications__introduce__list__item">
            <el-image
              class="img"
              :src="card.url && card.url[0]"
              :preview-src-list="card.url ? [...card.url] : []"
            ></el-image>
            <div class="desc">{{ card.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from '@/services';
export default {
  computed: {
    shopId() {
      return this.$route.params.id;
    },
    // 发票类型
    invoiceDesc() {
      if (this.qualifications.invoice.invoiceType.length == 0) return '';
      if (this.qualifications.invoice.invoiceType.length == 1) return this.qualifications.invoice.invoiceType[0];
      return this.qualifications.invoice.invoiceType.reduce((pre, cur) => {
        return `${pre}、${cur}`;
      });
    }
  },
  data() {
    return {
      qualifications: {
        summary: '',
        delivery: { minDeliveryAmount: '', parcelAmount: '', freight: '', remark: '' },
        invoice: { invoiceType: [], sendTime: '', desc: '' },
        certificates: [],
        businessCategory: ''
      }
    };
  },
  methods: {
    async getExtension() {
      const data = await api.shop.getExtension({ shopId: this.shopId });
      this.qualifications = data;
    }
  },
  created() {
    this.getExtension();
  }
};
</script>

<style lang="scss" scoped>
.qualifications {
  background: #f5f5f5;
  padding: 12px 0;

  padding-bottom: 56px;
  &__introduce {
    padding: 16px;
    background: #ffffff;

    &__title {
      font-size: 16px;
      font-weight: 400;
      color: #262626;
      line-height: 1;
      margin-bottom: 12px;
      .logo {
        height: 16px;
      }
      &::before {
        display: inline-block;
        content: '';
        height: 100%;
        vertical-align: middle;
      }
      img + span {
        margin-left: 6px;
      }
    }
    &__content {
      font-size: 12px;
      font-weight: 400;
      color: #595959;
      line-height: 1.5;
      & + .qualifications__introduce__content {
        margin-top: 8px;
      }
    }
    &__list {
      margin-top: 12px;
      display: flex;
      flex-wrap: wrap;
      &__item {
        background: #ffffff;
        text-align: center;
        .img {
          width: 280px;
          height: 280px;
          border: 1px solid #f5f5f5;
        }
        .desc {
          margin: 8px 0;
          font-size: 12px;
          font-weight: 400;
          color: #595959;
          line-height: 1.5;
        }
        & + .qualifications__introduce__list__item {
          margin-left: 26px;
        }
        &:nth-child(4n + 1) {
          margin-left: 0;
        }
      }
    }
    & + .qualifications__introduce {
      margin-top: 16px;
    }
  }
}
</style>
